import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { ShortUrl } from '@air/api';
import { type CustomFieldTypeName } from '@air/api/types';
import { useShortIdContext } from '@air/provider-short-id';
import { ONE_HOUR } from '@air/utilities';

import { getCustomFieldOptionsKey } from '~/constants/react-query-keys';
import { selectableCustomFields } from '~/swr-hooks/customFields/utils';

type UseGetCustomFieldOptionsParams = {
  customFieldId?: string;
  customFieldTypeName?: CustomFieldTypeName;
};
export const useContentCollectionCustomFieldOptions = ({
  customFieldId,
  customFieldTypeName,
}: UseGetCustomFieldOptionsParams) => {
  const { shortId } = useShortIdContext();

  const isEnabled = useMemo(() => {
    if (!customFieldId) {
      return false;
    }
    if (customFieldTypeName && selectableCustomFields.includes(customFieldTypeName)) {
      return true;
    } else {
      return false;
    }
  }, [customFieldId, customFieldTypeName]);

  return useQuery({
    queryKey: getCustomFieldOptionsKey(customFieldId),
    queryFn: () => {
      if (!customFieldId) {
        return undefined;
      }

      return ShortUrl.listCustomFieldValues(shortId, customFieldId);
    },
    enabled: isEnabled,
    staleTime: ONE_HOUR,
  });
};
